export type FullscreenButton = HTMLButtonElement;

function updateButton(button: FullscreenButton, target: HTMLElement): void {
  const active = document.fullscreenElement === target;
  button.classList.toggle('active', active);
  button.setAttribute('aria-pressed', String(active));
  button.title = active ? '退出视频全屏' : '视频全屏';
  button.setAttribute('aria-label', active ? '退出视频全屏' : '仅全屏显示远程画面');
  const label = button.querySelector<HTMLElement>('[data-fullscreen-label]');
  if (label) label.textContent = active ? '退出视频全屏' : '视频全屏';
}

export function bindFullscreenButton(button: FullscreenButton, target: HTMLElement): () => void {
  const onChange = (): void => updateButton(button, target);
  const onClick = async (): Promise<void> => {
    try {
      if (document.fullscreenElement === target) {
        await document.exitFullscreen();
      } else if (target.requestFullscreen) {
        if (document.fullscreenElement) await document.exitFullscreen();
        // 只放大远端画面容器，页面工具栏和设备管理页面不参与全屏。
        await target.requestFullscreen({ navigationUI: 'hide' });
      }
    } catch {
      // 浏览器未授权全屏时保持原页面，不打断远程控制。
    } finally {
      updateButton(button, target);
    }
  };

  button.addEventListener('click', onClick);
  document.addEventListener('fullscreenchange', onChange);
  updateButton(button, target);

  return () => {
    button.removeEventListener('click', onClick);
    document.removeEventListener('fullscreenchange', onChange);
  };
}
